<template>
  <div class="linkFormSectionWrap">
    <link-form-classify-card
      :dynamic-tags-list.sync="ruleForm.categoryIdList"
      :type="resourceType"
    />
  </div>
</template>

<script>
import LinkFormClassifyCard from '../../../views/resourceManage/genericResourceManage/association/LinkFormClassifyCard.vue'

export default {
  name: 'GenericResourceClassifySection',
  components: { LinkFormClassifyCard },
  props: {
    ruleForm: { type: Object, required: true },
    resourceType: { type: Number, default: 21 },
  },
  methods: {
    validate() {
      return Promise.resolve()
    },
    captureSnapshot() {
      return [...(this.ruleForm.categoryIdList || [])]
    },
  },
}
</script>
